export const users = [
    {
      id: 12,
      name: 'Karl',
    },
    {
      id: 18,
      name: 'Cecilia',
    },
  ]